(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('WikiSpace', WikiSpace);

    WikiSpace.$inject = ['$resource'];

    function WikiSpace($resource) {
        return $resource('api/wiki-spaces/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {method: 'GET'},
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();
